import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486036f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "proposal-header flex flex-row items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-back" }, null, -1))
const _hoisted_4 = { class: "font-medium proposal-header__title" }
const _hoisted_5 = { class: "text-big font-medium" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, " / ", -1))
const _hoisted_7 = { class: "font-light" }
const _hoisted_8 = {
  key: 0,
  class: "proposal-header__validity ml-4 font-medium"
}
const _hoisted_9 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_customer_header = _resolveComponent("customer-header")!
  const _component_badge = _resolveComponent("badge")!
  const _component_customer_details_modal = _resolveComponent("customer-details-modal")!
  const _component_modal = _resolveComponent("modal")!
  const _component_proposal_status = _resolveComponent("proposal-status")!
  const _component_proposal_settings_modal = _resolveComponent("proposal-settings-modal")!
  const _component_proposal_changelog_modal = _resolveComponent("proposal-changelog-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: {name: 'proposal.list'} }, {
        default: _withCtx(() => [
          _createVNode(_component_outline_button, {
            class: "proposal-header__back-button",
            type: "outline"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('proposal.header.title')), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_customer_header, {
          class: "proposal-header__client-info",
          customer: _ctx.customer
        }, null, 8, ["customer"])
      ]),
      _createVNode(_component_badge, {
        class: "proposal-header__badge",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showClientModal = true))
      }),
      _createVNode(_component_modal, {
        modelValue: _ctx.showClientModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showClientModal) = $event)),
        "hide-buttons": true
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.customer.companyName), 1),
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.customer.id), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_customer_details_modal, { customer: _ctx.customer }, null, 8, ["customer"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.validToFormatted && _ctx.validFromFormatted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Valid: " + _toDisplayString(_ctx.validFromFormatted) + " - " + _toDisplayString(_ctx.validToFormatted), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_proposal_status, {
        type: _ctx.proposal.status,
        class: "proposal-header__status"
      }, null, 8, ["type"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.proposal.id)
        ? (_openBlock(), _createBlock(_component_outline_button, {
            key: 0,
            type: "outline",
            class: "ml-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChangelogModal = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('proposal.changelog.button')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showGrossMarginButton)
        ? (_openBlock(), _createBlock(_component_outline_button, {
            key: 1,
            class: "ml-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSettings()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Settings ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showSaveButton)
        ? (_openBlock(), _createBlock(_component_outline_button, {
            key: 2,
            class: "ml-3",
            "is-loading": _ctx.isSaving,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('saveClick')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.button.save')), 1)
            ]),
            _: 1
          }, 8, ["is-loading"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showSettingsModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSettingsModal) = $event)),
      onConfirmClick: _ctx.handleSettingsConfirmClick,
      "block-confirm": !_ctx.areDatesValid || _ctx.isDescriptionEmpty || _ctx.areInitialsEmpty
    }, {
      title: _withCtx(() => [
        _createTextVNode("Settings")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_proposal_settings_modal, {
          modelValue: _ctx.settings,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings) = $event)),
          description: _ctx.proposal.description || '',
          "valid-from": _ctx.proposal.validFrom || null,
          "valid-to": _ctx.proposal.validTo || null,
          "created-by": _ctx.proposal.createdBy || '',
          "requested-by": _ctx.proposal.requestedBy || ''
        }, null, 8, ["modelValue", "description", "valid-from", "valid-to", "created-by", "requested-by"])
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick", "block-confirm"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showChangelogModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showChangelogModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('proposal.changelog.title')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.showChangelogModal)
          ? (_openBlock(), _createBlock(_component_proposal_changelog_modal, {
              key: 0,
              "proposal-id": String(_ctx.proposal.id)
            }, null, 8, ["proposal-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}